<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/a5zcmZ/tc-custom/9780374712730.jpg?1731883501466" alt="This image is the cover for the book Illuminations"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Illuminations
      </h1>
      <p class="bookDescription body article font2">
        <b>“Both a howl against the war in Afghanistan . . . and a multilayered, deeply felt tale of family, loss, memory, art, loyalty, secrecy and forgiveness.” —The New York Times Book Review</b><br/><br/><b>Longlisted for the Man Booker Prize</b><br/><br/>Anne Quirk’s life is built on stories—the lies she was told by the man she loved and the fictions she told herself to survive. Nobody remembers Anne now, but in her youth she was an artistic pioneer, a creator of groundbreaking documentary photographs. Her beloved grandson Luke, a captain with the Royal West Fusiliers in the British army, has inherited her habit of transforming reality. When his mission in Afghanistan goes horribly wrong, he returns to Scotland, where the secrets that have shaped his family begin to emerge. He and Anne set out to confront a mystery from her past among the Blackpool Illuminations—the dazzling lights that brighten the seaside town as the season turns to winter.<br/><br/><b>“Like its two main characters, this impressive novel has a double life, moving with imaginative daring between war and art, photography and fiction, and memory and secrets.” —<i>The Guardian</i></b><br/><br/><b>“Hypnotic . . . The Illuminations doesn’t exactly follow a plumb line: It shifts in time, perspective and place. But it’s occasionally lit up with a flash that makes the pieces of Anne’s story clear. It’s worth the trip into the dark.” —<i>The Globe and Mail</i></b><br/><br/><b>“A clever, expansive and powerfully charged novel about family connections and the unreliability of memory.” —<i>Star Tribune</i></b><br/><br/><b>“A lean yet rich family story built of small and crucial moments in memories and reality across three generations.” —<i>Kirkus Reviews</i> (starred review)</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew O'Hagan
      </h2>
      
      <p class="authorDescription body article"><B>Andrew O'Hagan</B> is one of Britain's most exciting and serious contemporary writers. He has twice been short-listed for the Man Booker Prize. He was voted one of <I>Granta</I>'s Best of Young British Novelists in 2003. He has won the Los Angeles Times Book Award and the E. M. Forster Award from the American Academy of Arts and Letters. He is the author of <I>Our Fathers, Be Near Me, The Illuminations</I>, among other books. He lives in London.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ffdfc230